<template>
	<b-form
		ref="form"
		@submit.prevent="setClockPost"
	>
		<b-form-group>
			<vue-typeahead-bootstrap
				class="mb-4"
				v-model="query"
				:data="clocks"
				:serializer="item => item.Name"
				@hit="loadClock($event)"
				placeholder="Search Clocks"
			/>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Add Clock</b-button>

	</b-form>
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import ClockService from "@/api-services/clock.service";

export default {
	name: "SetClock",

	// things we want to use
	components: {
		VueTypeaheadBootstrap
	},

	// things we have inherited from our parent
	props: [],

	// data we bind to, escapements need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			query: "",
			clock: {},
			clocks: []
		};
	},

	// things we do to data
	methods: {
		setClockPost() {
			this.$emit("add", this.clock);
		},

		loadClock(clock) {
			this.clock = clock;
		}
	},

	// data we watch for changes
	watch: {
		// When the query value changes, fetch new results from
		// the API - in practice this action should be debounced
		query(newQuery) {
			ClockService.search(newQuery).then(res => {
				this.clocks = res.data;
			});
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/set-clock.vue